import React from "react";
import { ChatPlusCalendarTimeSuggestionSync } from "../chat/ai-chat/ChatPlusCalendarTimeSuggestionSync";
import ErrorBoundary from "../error-boundary/ErrorBoundary";
import { SharedProposalTimeSuggestionSync } from "../shareable-proposal/SharedProposalTimeSuggestionSync";
import { useSharedProposalContext } from "../shareable-proposal/hooks/SharedProposalProvider";
import { PlannerProvider } from "../web-app-calendar/Context";
import { CalendarWeek } from "../web-app-calendar/calendar-week/CalendarWeek";
import { CalendarColorsSync } from "../web-app-calendar/hooks/CalendarColorsSync";
import usePlannerMetaData from "../web-app-calendar/hooks/usePlannerMetaData";
import { PlannerToolbar } from "../web-app-calendar/planner-toolbar/PlannerToolbar";
import { useChatPlusCalEventCards } from "./hooks/useChatPlusCalEventCards";
import { DismissedConflictClusterProvider } from "./util/DismissedConflictClusterContext";

const Calendar = () => {
  const {
    userCalendarIds,
    colorSettings,
    workingHourBounds,
    workingHours,
    loading,
    error,
  } = usePlannerMetaData();

  const { proposal: sharedProposal } = useSharedProposalContext();

  if (loading) {
    return null;
  }

  if (error) {
    return <div>error</div>;
  }

  return (
    <DismissedConflictClusterProvider initValue={[]}>
      <PlannerProvider
        useEventCardsHook={useChatPlusCalEventCards}
        userCalendarIds={userCalendarIds}
        colorSettings={colorSettings}
        workingHourBounds={workingHourBounds}
        workingHours={workingHours}
      >
        <div className="cw-w-full cw-h-full cw-overflow-hidden cw-mr-[1px]">
          <PlannerToolbar showCalendarPeek={true} />
          <CalendarColorsSync />
          {sharedProposal && <SharedProposalTimeSuggestionSync />}
          {!sharedProposal && <ChatPlusCalendarTimeSuggestionSync />}
          <ErrorBoundary>
            <CalendarWeek />
          </ErrorBoundary>
        </div>
      </PlannerProvider>
    </DismissedConflictClusterProvider>
  );
};

export default Calendar;
